<template>
  <hic-dialog title="会诊编辑" :visible="visible" @open="open" @close="cancel" width="40rem" top="10vh">
    <el-row style="padding: 0 2rem">
      <el-descriptions title="基本信息" :column="5">
        <el-descriptions-item label="姓名">{{ entity.patientName }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ entity.patientGender | dictText("Gender") }}</el-descriptions-item>
        <el-descriptions-item label="年龄">{{ entity.patientAge }}</el-descriptions-item>
        <el-descriptions-item label="科室">{{ entity.deptCode | dictText("Dept") }}</el-descriptions-item>
        <el-descriptions-item label="床位">{{ entity.bedNo }}</el-descriptions-item>
        <el-descriptions-item label="主要诊断" :span="4">{{ entity.diagnosisName }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="会诊信息" :column="2" labelClassName="left-pad" contentClassName="left-pad">
        <el-descriptions-item label="类型">
          <hic-dict-selector dict-type="ConsultationType" v-model="value.type" auto />
        </el-descriptions-item>
        <el-descriptions-item label="日期">
          <el-date-picker size="small" v-model="value.planDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择预约会诊时间：" style="width: 80%"></el-date-picker>
          <el-checkbox v-model="value.ifEmergency" label="加急" class="left-pad" />
        </el-descriptions-item>
        <el-descriptions-item label="病情">
          <el-input type="textarea" :rows="3" v-model="value.situation" placeholder="请输入病情及诊疗情况" size="small" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="目的">
          <el-input type="textarea" :rows="3" v-model="value.purpose" placeholder="请输入会诊目的" size="small" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="2"><el-input type="text" v-model="value.memo" size="small" /></el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="会诊科室" :column="2" labelClassName="left-pad" contentClassName="left-pad">
        <template slot="extra">
          <el-button v-if="!value.id" type="primary" size="mini" icon="el-icon-plus" circle plain @click="addTarget"></el-button>
        </template>
        <el-descriptions-item label="科室">
          <hic-dict-selector dict-type="Dept" v-model="value.targetDeptCode"></hic-dict-selector>
        </el-descriptions-item>
        <el-descriptions-item label="医师">
          <hic-staff-selector :dept="value.targetDeptCode" v-model="value.targetDoctorCode" :name.sync="value.targetDoctorName" style="width: 85%"></hic-staff-selector>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions v-for="(target, index) in targets" :key="index" title="" :column="2" labelClassName="left-pad" contentClassName="left-pad">
        <el-descriptions-item label="科室">
          <hic-dict-selector dict-type="Dept" v-model="target.deptCode"></hic-dict-selector>
        </el-descriptions-item>
        <el-descriptions-item label="医师">
          <hic-staff-selector :dept="target.deptCode" v-model="target.doctorCode" :name.sync="target.doctorName" style="width: 85%"></hic-staff-selector>
          <el-button type="danger" size="small" icon="el-icon-delete" circle plain @click="delTarget(index)" class="left-pad"></el-button>
        </el-descriptions-item>
      </el-descriptions>
    </el-row>
    <template slot="footer">
      <el-button type="info" @click="$emit('update:visible', false)">取 消</el-button>
      <!-- <el-button type="warning" v-if="value.state == '草稿'" @click="save('草稿')" class="left-pad">暂存</el-button> -->
      <el-button type="primary" @click="save('申请中')" class="left-pad">提 交</el-button>
    </template>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {},
    props: {
      entity: Object,
      value: Object,
      visible: Boolean,
    },
    data() {
      return {
        meta: {
          saving: false,
        },
        targets: [],
      };
    },
    computed: {
      ...mapGetters(["dict", "getDict", "Enum"]),
    },
    methods: {
      open() {
        this.targets = [];
      },
      cancel() {
        this.$emit("cancel");
        this.$emit("update:visible", false);
      },
      save(state) {
        if (!this.value.planDate) {
          this.$message.warning("会诊日期不能为空！");
          return;
        }
        if (!this.value.purpose) {
          this.$message.warning("会诊目的不能为空！");
          return;
        }
        if (!this.value.targetDeptCode) {
          this.$message.warning("会诊科室不能为空！");
          return;
        }
        if (this.targets.length) {
          this.value.targets = this.targets;
        }
        this.value.state = state
        this.meta.saving = true;
        api.Consultation.save(this.value)
          .then((res) => {
            this.$message.success("保存成功");
            this.$emit("ok");
            this.$emit("update:visible", false);
          })
          .catch((err) => {
            this.$message.error(error);
          })
          .finally(() => {
            this.meta.saving = false;
          });
      },
      addTarget() {
        this.targets.push({ deptCode: null, doctorCode: null, doctorName: null });
      },
      delTarget(index) {
        this.targets.splice(index, 1);
      },
    },
  };
</script>
